import React, { useState, useEffect } from 'react';
import { Package, Church, Flower2, FileText, Calculator } from 'lucide-react';
import { Slider } from './ui/slider';
import CostCalculatorWizard from './CostCalculatorWizard';

const CostsSection = ({ onSetCalculatorRef }) => {
  const [insuranceSum, setInsuranceSum] = useState(10000);
  const [showWizard, setShowWizard] = useState(false);

  useEffect(() => {
    if (onSetCalculatorRef) {
      onSetCalculatorRef(() => () => setShowWizard(true));
    }
  }, [onSetCalculatorRef]);

  const costs = [
    {
      icon: Package,
      title: 'Bestattung (Sarg / Urne)',
      range: '2.000 – 4.500 €',
      description: 'Kosten für Sarg oder Urne, Bestatterdienstleistungen, Überführung und weitere notwendige Leistungen.'
    },
    {
      icon: Church,
      title: 'Trauerfeier & Abschied',
      range: '1.000 – 3.500 €',
      description: 'Organisation und Durchführung der Trauerfeier, Blumenschmuck, Trauerredner und musikalische Begleitung.'
    },
    {
      icon: Flower2,
      title: 'Grabstelle & Grabstein',
      range: '2.000 – 4.000 €',
      description: 'Grabnutzungsrechte, Grabstein bzw. Grabplatte, Bepflanzung und erstmalige Grabgestaltung.'
    },
    {
      icon: FileText,
      title: 'Sonstige Wünsche',
      range: '500 – 1.500 €',
      description: 'Traueranzeigen, Danksagungskarten, Trauerkaffee und weitere individuelle Wünsche.'
    }
  ];

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0
    }).format(value);
  };

  return (
    <section className="section section-beige costs-section">
      <div className="container-custom">
        <div className="section-header fade-in">
          <p className="section-accent">✦ KOSTENTRANSPARENZ</p>
          <h2 className="headline-secondary">
            Was Bestattungskosten typischerweise umfassen
          </h2>
          <p className="subheadline">
            Die Gesamtkosten einer Bestattung variieren je nach Region und persönlichen Wünschen. 
            Diese Übersicht hilft Ihnen, eine passende Versicherungssumme zu finden.
          </p>
        </div>

        <div className="costs-grid">
          {costs.map((cost, index) => {
            const IconComponent = cost.icon;
            return (
              <div key={index} className="cost-card fade-in" style={{ animationDelay: `${index * 0.1}s` }}>
                <h3>
                  <IconComponent className="icon" />
                  {cost.title}
                </h3>
                <div className="cost-range">{cost.range}</div>
                <p className="cost-description">{cost.description}</p>
              </div>
            );
          })}
        </div>

        <div className="cost-summary fade-in">
          <h3>Kosten einer Bestattung im Überblick</h3>
          <div className="total-range">7.500 EUR – 15.000 EUR</div>
          <p>
            Je nach individuellen Vorstellungen und regionalen Unterschieden. 
            Wir beraten Sie gerne zu Ihrer passenden Absicherung.
          </p>
        </div>

        <div className="cost-calculator fade-in">
          <div className="calculator-content">
            <Calculator className="icon-large mb-4" />
            <h3 className="headline-tertiary">Detaillierte Kostenberechnung</h3>
            <p className="mb-6">
              Nutzen Sie unseren interaktiven Rechner für eine individuelle, detaillierte Kostenschätzung basierend auf Ihren persönlichen Wünschen.
            </p>
            
            <button 
              onClick={() => setShowWizard(true)}
              className="btn-primary mx-auto"
              style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
            >
              <Calculator size={20} />
              Kostenrechner starten
            </button>
          </div>
        </div>
        
        {showWizard && (
          <CostCalculatorWizard onClose={() => setShowWizard(false)} />
        )}
      </div>
    </section>
  );
};

export default CostsSection;
